// @flow
module.exports = {
  JAPAN_PREFECTURE_ORDER_MAP: {
    Hokkaido: 0,
    北海道: 0, // Japanese, Simplified Chinese, and Traditional Chinese
    홋카이도: 0, // Korean
    Aomori: 1,
    青森: 1, // Japanese, Simplified Chinese, and Traditional Chinese
    아오모리: 1, // Korean
    Iwate: 2,
    岩手: 2, // Japanese, Simplified Chinese, and Traditional Chinese
    이와테: 2, // Korean
    Akita: 3,
    秋田: 3, // Japanese, Simplified Chinese, and Traditional Chinese
    아키타: 3, // Korean
    Yamagata: 4,
    山形: 4, // Japanese, Simplified Chinese, and Traditional Chinese
    야마가타: 4, // Korean
    Miyagi: 5,
    宮城: 5, // Japanese and Traditional Chinese
    미야기: 5, // Korean
    宫城: 5, // Simplified Chinese
    Fukushima: 6,
    福島: 6, // Japanese and Traditional Chinese
    후쿠시마: 6, // Korean
    福岛: 6, // Simplified Chinese
    Ibaraki: 7,
    茨城: 7, // Japanese, Simplified Chinese, and Traditional Chinese
    이바라키: 7, // Korean
    Tochigi: 8,
    栃木: 8, // Japanese, Simplified Chinese, and Traditional Chinese
    도치기: 8, // Korean
    Gunma: 9,
    群馬: 9, // Japanese and Traditional Chinese
    군마: 9, // Korean
    群马: 9, // Simplified Chinese
    Niigata: 10,
    新潟: 10, // Japanese, Simplified Chinese, and Traditional Chinese
    니가타: 10, // Korean
    Saitama: 11,
    埼玉: 11, // Japanese, Simplified Chinese, and Traditional Chinese
    사이타마: 11, // Korean
    Chiba: 12,
    千葉: 12, // Japanese and Traditional Chinese
    치바: 12, // Korean
    千叶: 12, // Simplified Chinese
    Tokyo: 13,
    東京: 13, // Japanese and Traditional Chinese
    도쿄: 13, // Korean
    东京: 13, // Simplified Chinese
    Kanagawa: 14,
    神奈川: 14, // Japanese, Simplified Chinese, and Traditional Chinese
    가나가와: 14, // Korean
    Yamanashi: 15,
    山梨: 15, // Japanese, Simplified Chinese, and Traditional Chinese
    야마나시: 15, // Korean
    Nagano: 16,
    長野: 16, // Japanese and Traditional Chinese
    나가노: 16, // Korean
    长野: 16, // Simplified Chinese
    Shizuoka: 17,
    静岡: 17, // Japanese
    시즈오카: 17, // Korean
    静冈: 17, // Simplified Chinese
    靜岡: 17, // Traditional Chinese
    Aichi: 18,
    愛知: 18, // Japanese and Traditional Chinese
    아이치: 18, // Korean
    爱知: 18, // Simplified Chinese
    Gifu: 19,
    岐阜: 19, // Japanese, Simplified Chinese, and Traditional Chinese
    기후: 19, // Korean
    Toyama: 20,
    富山: 20, // Japanese, Simplified Chinese, and Traditional Chinese
    도야마: 20, // Korean
    Ishikawa: 21,
    石川: 21, // Japanese, Simplified Chinese, and Traditional Chinese
    이시카와: 21, // Korean
    Fukui: 22,
    福井: 22, // Japanese, Simplified Chinese, and Traditional Chinese
    후쿠이: 22, // Korean
    Mie: 23,
    三重: 23, // Japanese, Simplified Chinese, and Traditional Chinese
    미에: 23, // Korean
    Shiga: 24,
    滋賀: 24, // Japanese and Traditional Chinese
    시가: 24, // Korean
    滋贺: 24, // Simplified Chinese
    Kyoto: 25,
    京都: 25, // Japanese, Simplified Chinese, and Traditional Chinese
    교토: 25, // Korean
    Osaka: 26,
    大阪: 26, // Japanese, Simplified Chinese, and Traditional Chinese
    오사카: 26, // Korean
    Hyogo: 27,
    兵庫: 27, // Japanese and Traditional Chinese
    효고: 27, // Korean
    兵库: 27, // Simplified Chinese
    Nara: 28,
    奈良: 28, // Japanese, Simplified Chinese, and Traditional Chinese
    나라: 28, // Korean
    Wakayama: 29,
    和歌山: 29, // Japanese, Simplified Chinese, and Traditional Chinese
    와카야마: 29, // Korean
    Tottori: 30,
    鳥取: 30, // Japanese and Traditional Chinese
    토토리: 30, // Korean
    鸟取: 30, // Simplified Chinese
    Shimane: 31,
    島根: 31, // Japanese and Traditional Chinese
    시마네: 31, // Korean
    岛根: 31, // Simplified Chinese
    Okayama: 32,
    岡山: 32, // Japanese and Traditional Chinese
    오카야마: 32, // Korean
    冈山: 32, // Simplified Chinese
    Hiroshima: 33,
    広島: 33, // Japanese
    히로시마: 33, // Korean
    广岛: 33, // Simplified Chinese
    廣島: 33, // Traditional Chinese
    Yamaguchi: 34,
    山口: 34, // Japanese, Simplified Chinese, and Traditional Chinese
    야마구치: 34, // Korean
    Kagawa: 35,
    香川: 35, // Japanese, Simplified Chinese, and Traditional Chinese
    카가와: 35, // Korean
    Tokushima: 36,
    徳島: 36, // Japanese
    도쿠시마: 36, // Korean
    德岛: 36, // Simplified Chinese
    德島: 36, // Traditional Chinese
    Ehime: 37,
    愛媛: 37, // Japanese and Traditional Chinese
    에히메: 37, // Korean
    爱媛: 37, // Simplified Chinese
    Kochi: 38,
    高知: 38, // Japanese, Simplified Chinese, and Traditional Chinese
    고치: 38, // Korean
    Fukuoka: 39,
    福岡: 39, // Japanese and Traditional Chinese
    후쿠오카: 39, // Korean
    福冈: 39, // Simplified Chinese
    Saga: 40,
    佐賀: 40, // Japanese and Traditional Chinese
    사가: 40, // Korean
    佐贺: 40, // Simplified Chinese
    Nagasaki: 41,
    長崎: 41, // Japanese and Traditional Chinese
    나가사키: 41, // Korean
    长崎: 41, // Simplified Chinese
    Kumamoto: 42,
    熊本: 42, // Japanese, Simplified Chinese, and Traditional Chinese
    구마모토: 42, // Korean
    Oita: 43,
    大分: 43, // Japanese, Simplified Chinese, and Traditional Chinese
    오이타: 43, // Korean
    Miyazaki: 44,
    宮崎: 44, // Japanese and Traditional Chinese
    미야자키: 44, // Korean
    宫崎: 44, // Simplified Chinese
    Kagoshima: 45,
    鹿児島: 45, // Japanese
    가고시마: 45, // Korean
    鹿儿岛: 45, // Simplified Chinese
    鹿兒島: 45, // Traditional Chinese
    Okinawa: 46,
    沖縄: 46, // Japanese
    오키나와: 46, // Korean
    冲绳: 46, // Simplified Chinese
    沖繩: 46 // Traditional Chinese
  },
  SHOP_CARD_URLS_FASTPASS: [
    [
      'tsuta79-tokyo',
      'https://www.tablecheck.com/tsuta79-tokyo',
      'https://www.tablecheck.com/shops/tsuta79-tokyo/reserve',
      'https://www.tablecheck.com/en/tsuta79-tokyo?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/tsuta79-tokyo/reserve?utm_source=fastpass'
    ],
    [
      'ginza-hachigou',
      'https://www.tablecheck.com/ginza-hachigou',
      'https://www.tablecheck.com/shops/ginza-hachigou/reserve',
      'https://www.tablecheck.com/en/ginza-hachigou?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ginza-hachigou/reserve?utm_source=fastpass'
    ],
    [
      'ramenbreakbeats',
      'https://www.tablecheck.com/ramenbreakbeats',
      'https://www.tablecheck.com/shops/ramenbreakbeats/reserve',
      'https://www.tablecheck.com/en/ramenbreakbeats?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ramenbreakbeats/reserve?utm_source=fastpass'
    ],
    [
      'ramen-gokan',
      'https://www.tablecheck.com/ramen-gokan',
      'https://www.tablecheck.com/shops/ramen-gokan/reserve',
      'https://www.tablecheck.com/en/ramen-gokan?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ramen-gokan/reserve?utm_source=fastpass'
    ],
    [
      'ramen-feel',
      'https://www.tablecheck.com/ramen-feel',
      'https://www.tablecheck.com/shops/ramen-feel/reserve',
      'https://www.tablecheck.com/en/ramen-feel?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ramen-feel/reserve?utm_source=fastpass'
    ],
    [
      'devchanramen',
      'https://www.tablecheck.com/devchanramen',
      'https://www.tablecheck.com/shops/devchanramen/reserve',
      'https://www.tablecheck.com/en/devchanramen?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/devchanramen/reserve?utm_source=fastpass'
    ],
    [
      'uzutokaminari',
      'https://www.tablecheck.com/uzutokaminari',
      'https://www.tablecheck.com/shops/uzutokaminari/reserve',
      'https://www.tablecheck.com/en/uzutokaminari?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/uzutokaminari/reserve?utm_source=fastpass'
    ],
    [
      'kamigatarainbow',
      'https://www.tablecheck.com/kamigatarainbow',
      'https://www.tablecheck.com/shops/kamigatarainbow/reserve',
      'https://www.tablecheck.com/en/kamigatarainbow?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/kamigatarainbow/reserve?utm_source=fastpass'
    ],
    [
      'ramenkohaku',
      'https://www.tablecheck.com/ramenkohaku',
      'https://www.tablecheck.com/shops/ramenkohaku/reserve',
      'https://www.tablecheck.com/en/ramenkohaku?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ramenkohaku/reserve?utm_source=fastpass'
    ],
    [
      'torisobazagin-niboshi',
      'https://www.tablecheck.com/torisobazagin-niboshi',
      'https://www.tablecheck.com/shops/torisobazagin-niboshi/reserve',
      'https://www.tablecheck.com/en/torisobazagin-niboshi?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/torisobazagin-niboshi/reserve?utm_source=fastpass'
    ],
    [
      'udonshin',
      'https://www.tablecheck.com/udonshin',
      'https://www.tablecheck.com/shops/udonshin/reserve',
      'https://www.tablecheck.com/en/udonshin?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/udonshin/reserve?utm_source=fastpass'
    ],
    [
      'tonchibo',
      'https://www.tablecheck.com/tonchibo',
      'https://www.tablecheck.com/shops/tonchibo/reserve',
      'https://www.tablecheck.com/en/tonchibo?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/tonchibo/reserve?utm_source=fastpass'
    ],
    [
      'flippers-shibuya',
      'https://www.tablecheck.com/flippers-shibuya',
      'https://www.tablecheck.com/shops/flippers-shibuya/reserve',
      'https://www.tablecheck.com/en/flippers-shibuya?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/flippers-shibuya/reserve?utm_source=fastpass'
    ],
    [
      'minato-sushi-tsushima',
      'https://www.tablecheck.com/minato-sushi-tsushima',
      'https://www.tablecheck.com/shops/minato-sushi-tsushima/reserve',
      'https://www.tablecheck.com/en/minato-sushi-tsushima?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/minato-sushi-tsushima/reserve?utm_source=fastpass'
    ],
    [
      'kusaka-curry',
      'https://www.tablecheck.com/kusaka-curry',
      'https://www.tablecheck.com/shops/kusaka-curry/reserve',
      'https://www.tablecheck.com/en/kusaka-curry?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/kusaka-curry/reserve?utm_source=fastpass'
    ],
    [
      'jikitan-momiji',
      'https://www.tablecheck.com/jikitan-momiji',
      'https://www.tablecheck.com/shops/jikitan-momiji/reserve',
      'https://www.tablecheck.com/en/jikitan-momiji?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/jikitan-momiji/reserve?utm_source=fastpass'
    ],
    [
      'teshikaga-ramen-yokocho',
      'https://www.tablecheck.com/teshikaga-ramen-yokocho',
      'https://www.tablecheck.com/shops/teshikaga-ramen-yokocho/reserve',
      'https://www.tablecheck.com/en/teshikaga-ramen-yokocho?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/teshikaga-ramen-yokocho/reserve?utm_source=fastpass'
    ],
    [
      'mendokoro-honda-akihabara',
      'https://www.tablecheck.com/mendokoro-honda-akihabara',
      'https://www.tablecheck.com/shops/mendokoro-honda-akihabara/reserve',
      'https://www.tablecheck.com/en/mendokoro-honda-akihabara?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/mendokoro-honda-akihabara/reserve?utm_source=fastpass'
    ],
    [
      'menya-itto',
      'https://www.tablecheck.com/menya-itto',
      'https://www.tablecheck.com/shops/menya-itto/reserve',
      'https://www.tablecheck.com/en/menya-itto?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/menya-itto/reserve?utm_source=fastpass'
    ],
    [
      'ramen-ajisai',
      'https://www.tablecheck.com/ramen-ajisai',
      'https://www.tablecheck.com/shops/ramen-ajisai/reserve',
      'https://www.tablecheck.com/en/ramen-ajisai?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ramen-ajisai/reserve?utm_source=fastpass'
    ],
    [
      'r-kyoto',
      'https://www.tablecheck.com/r-kyoto',
      'https://www.tablecheck.com/shops/r-kyoto/reserve',
      'https://www.tablecheck.com/en/r-kyoto?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/r-kyoto/reserve?utm_source=fastpass'
    ],
    [
      'koimenya-sakuna',
      'https://www.tablecheck.com/koimenya-sakuna',
      'https://www.tablecheck.com/shops/koimenya-sakuna/reserve',
      'https://www.tablecheck.com/en/koimenya-sakuna?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/koimenya-sakuna/reserve?utm_source=fastpass'
    ],
    [
      'ramen-kuon2020',
      'https://www.tablecheck.com/ramen-kuon2020',
      'https://www.tablecheck.com/shops/ramen-kuon2020/reserve',
      'https://www.tablecheck.com/en/ramen-kuon2020?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ramen-kuon2020/reserve?utm_source=fastpass'
    ],
    [
      'zundbar',
      'https://www.tablecheck.com/zundbar',
      'https://www.tablecheck.com/shops/zundbar/reserve',
      'https://www.tablecheck.com/en/zundbar?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/zundbar/reserve?utm_source=fastpass'
    ],
    [
      'ramen-ikeshima',
      'https://www.tablecheck.com/ramen-ikeshima',
      'https://www.tablecheck.com/shops/ramen-ikeshima/reserve',
      'https://www.tablecheck.com/en/ramen-ikeshima?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ramen-ikeshima/reserve?utm_source=fastpass'
    ],
    [
      'yelo-jp',
      'https://www.tablecheck.com/yelo-jp',
      'https://www.tablecheck.com/shops/yelo-jp/reserve',
      'https://www.tablecheck.com/en/yelo-jp?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/yelo-jp/reserve?utm_source=fastpass'
    ],
    [
      'uewomuite1027',
      'https://www.tablecheck.com/uewomuite1027',
      'https://www.tablecheck.com/shops/uewomuite1027/reserve',
      'https://www.tablecheck.com/en/uewomuite1027?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/uewomuite1027/reserve?utm_source=fastpass'
    ],
    [
      'kooriya-peace',
      'https://www.tablecheck.com/kooriya-peace',
      'https://www.tablecheck.com/shops/kooriya-peace/reserve',
      'https://www.tablecheck.com/en/kooriya-peace?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/kooriya-peace/reserve?utm_source=fastpass'
    ],
    [
      'ancredore',
      'https://www.tablecheck.com/ancredore',
      'https://www.tablecheck.com/shops/ancredore/reserve',
      'https://www.tablecheck.com/en/ancredore?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ancredore/reserve?utm_source=fastpass'
    ],
    [
      'sakanouecafe',
      'https://www.tablecheck.com/sakanouecafe',
      'https://www.tablecheck.com/shops/sakanouecafe/reserve',
      'https://www.tablecheck.com/en/sakanouecafe?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/sakanouecafe/reserve?utm_source=fastpass'
    ],
    [
      'mensouan-sunada',
      'https://www.tablecheck.com/mensouan-sunada',
      'https://www.tablecheck.com/shops/mensouan-sunada/reserve',
      'https://www.tablecheck.com/en/mensouan-sunada?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/mensouan-sunada/reserve?utm_source=fastpass'
    ],
    [
      'kuromatu',
      'https://www.tablecheck.com/kuromatu',
      'https://www.tablecheck.com/shops/kuromatu/reserve',
      'https://www.tablecheck.com/en/kuromatu?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/kuromatu/reserve?utm_source=fastpass'
    ],
    [
      'narukamishokudo',
      'https://www.tablecheck.com/narukamishokudo',
      'https://www.tablecheck.com/shops/narukamishokudo/reserve',
      'https://www.tablecheck.com/en/narukamishokudo?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/narukamishokudo/reserve?utm_source=fastpass'
    ],
    [
      'teutikagaribi',
      'https://www.tablecheck.com/teutikagaribi',
      'https://www.tablecheck.com/shops/teutikagaribi/reserve',
      'https://www.tablecheck.com/en/teutikagaribi?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/teutikagaribi/reserve?utm_source=fastpass'
    ],
    [
      'menson-rage-azabudai',
      'https://www.tablecheck.com/menson-rage-azabudai',
      'https://www.tablecheck.com/shops/menson-rage-azabudai/reserve',
      'https://www.tablecheck.com/en/menson-rage-azabudai?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/menson-rage-azabudai/reserve?utm_source=fastpass'
    ],
    [
      'kanmi-mitsuya',
      'https://www.tablecheck.com/kanmi-mitsuya',
      'https://www.tablecheck.com/shops/kanmi-mitsuya/reserve',
      'https://www.tablecheck.com/en/kanmi-mitsuya?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/kanmi-mitsuya/reserve?utm_source=fastpass'
    ],
    [
      'ramenjazzybeats',
      'https://www.tablecheck.com/ramenjazzybeats',
      'https://www.tablecheck.com/shops/ramenjazzybeats/reserve',
      'https://www.tablecheck.com/en/ramenjazzybeats?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/ramenjazzybeats/reserve?utm_source=fastpass'
    ],
    [
      'cyukasobaaoki',
      'https://www.tablecheck.com/cyukasobaaoki',
      'https://www.tablecheck.com/shops/cyukasobaaoki/reserve',
      'https://www.tablecheck.com/en/cyukasobaaoki?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/cyukasobaaoki/reserve?utm_source=fastpass'
    ],
    [
      'yoridocoro',
      'https://www.tablecheck.com/yoridocoro',
      'https://www.tablecheck.com/shops/yoridocoro/reserve',
      'https://www.tablecheck.com/en/yoridocoro?utm_source=fastpass',
      'https://www.tablecheck.com/en/shops/yoridocoro/reserve?utm_source=fastpass'
    ]
  ],
  SHOP_CARD_URLS_FRANCE_RESTAURANT_WEEK: [
    [
      'otowa-restaurant',
      'https://www.tablecheck.com/otowa-restaurant',
      'https://www.tablecheck.com/shops/otowa-restaurant/reserve',
      '6673917d3235ca0436f002a4',
      'https://www.tablecheck.com/ja/otowa-restaurant?menu_lists[]=6673917d3235ca0436f002a4&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/otowa-restaurant/reserve?menu_lists[]=6673917d3235ca0436f002a4&utm_source=france_restaurant_week'
    ],
    [
      'ceruleantower-coucagno',
      'https://www.tablecheck.com/ceruleantower-coucagno',
      'https://www.tablecheck.com/shops/ceruleantower-coucagno/reserve',
      '6687ac04fff17960e351b0be',
      'https://www.tablecheck.com/ja/ceruleantower-coucagno?menu_lists[]=6687ac04fff17960e351b0be&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/ceruleantower-coucagno/reserve?menu_lists[]=6687ac04fff17960e351b0be&utm_source=france_restaurant_week'
    ],
    [
      'la-brique',
      'https://www.tablecheck.com/la-brique',
      'https://www.tablecheck.com/shops/la-brique/reserve',
      '666fa83d061f6c2d7f2e42be',
      'https://www.tablecheck.com/ja/la-brique?menu_lists[]=666fa83d061f6c2d7f2e42be&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/la-brique/reserve?menu_lists[]=666fa83d061f6c2d7f2e42be&utm_source=france_restaurant_week'
    ],
    [
      'aligne',
      'https://www.tablecheck.com/aligne',
      'https://www.tablecheck.com/shops/aligne/reserve',
      '666fbeccda27f74b362e46f1',
      'https://www.tablecheck.com/ja/aligne?menu_lists[]=666fbeccda27f74b362e46f1&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/aligne/reserve?menu_lists[]=666fbeccda27f74b362e46f1&utm_source=france_restaurant_week'
    ],
    [
      'chezmasa',
      'https://www.tablecheck.com/chezmasa',
      'https://www.tablecheck.com/shops/chezmasa/reserve',
      '666fccfd987ee0a949418b7f',
      'https://www.tablecheck.com/ja/chezmasa?menu_lists[]=666fccfd987ee0a949418b7f&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/chezmasa/reserve?menu_lists[]=666fccfd987ee0a949418b7f&utm_source=france_restaurant_week'
    ],
    [
      'restaurant-sio',
      'https://www.tablecheck.com/restaurant-sio',
      'https://www.tablecheck.com/shops/restaurant-sio/reserve',
      '667397927965e29d69dc807b',
      'https://www.tablecheck.com/ja/restaurant-sio?menu_lists[]=667397927965e29d69dc807b&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/restaurant-sio/reserve?menu_lists[]=667397927965e29d69dc807b&utm_source=france_restaurant_week'
    ],
    [
      'rn',
      'https://www.tablecheck.com/rn',
      'https://www.tablecheck.com/shops/rn/reserve',
      '666fd510772c7f6fd8aa9e39',
      'https://www.tablecheck.com/ja/rn?menu_lists[]=666fd510772c7f6fd8aa9e39&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/rn/reserve?menu_lists[]=666fd510772c7f6fd8aa9e39&utm_source=france_restaurant_week'
    ],
    [
      'le-parfum',
      'https://www.tablecheck.com/le-parfum',
      'https://www.tablecheck.com/shops/le-parfum/reserve',
      '6670ee10c27212ed9aaac25b',
      'https://www.tablecheck.com/ja/le-parfum?menu_lists[]=6670ee10c27212ed9aaac25b&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/le-parfum/reserve?menu_lists[]=6670ee10c27212ed9aaac25b&utm_source=france_restaurant_week'
    ],
    [
      'clos-des-gourmets',
      'https://www.tablecheck.com/clos-des-gourmets',
      'https://www.tablecheck.com/shops/clos-des-gourmets/reserve',
      '666ff1d3da27f74b362e506e',
      'https://www.tablecheck.com/ja/clos-des-gourmets?menu_lists[]=666ff1d3da27f74b362e506e&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/clos-des-gourmets/reserve?menu_lists[]=666ff1d3da27f74b362e506e&utm_source=france_restaurant_week'
    ],
    [
      'lintemporel',
      'https://www.tablecheck.com/lintemporel',
      'https://www.tablecheck.com/lintemporel/reserve',
      '6672421cb429002ff1f1aa22',
      'https://www.tablecheck.com/ja/lintemporel?menu_lists[]=6672421cb429002ff1f1aa22&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/lintemporel/reserve?menu_lists[]=6672421cb429002ff1f1aa22&utm_source=france_restaurant_week'
    ],
    [
      'm-cerisier',
      'https://www.tablecheck.com/m-cerisier',
      'https://www.tablecheck.com/shops/m-cerisier/reserve',
      '66724a8f867812ac64f1a961',
      'https://www.tablecheck.com/ja/m-cerisier?menu_lists[]=66724a8f867812ac64f1a961&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/m-cerisier/reserve?menu_lists[]=66724a8f867812ac64f1a961&utm_source=france_restaurant_week'
    ],
    [
      'pbtpaulbocuse',
      'https://www.tablecheck.com/pbtpaulbocuse',
      'https://www.tablecheck.com/shops/pbtpaulbocuse/reserve',
      '667ba55a701f686702fd8e2b',
      'https://www.tablecheck.com/ja/pbtpaulbocuse?menu_lists[]=667ba55a701f686702fd8e2b&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/pbtpaulbocuse/reserve?menu_lists[]=667ba55a701f686702fd8e2b&utm_source=france_restaurant_week'
    ],
    [
      'pbkpaulbocuse',
      'https://www.tablecheck.com/pbkpaulbocuse',
      'https://www.tablecheck.com/shops/pbkpaulbocuse/reserve',
      '667ba8e4aded4d4f8076fa48',
      'https://www.tablecheck.com/ja/pbkpaulbocuse?menu_lists[]=667ba8e4aded4d4f8076fa48&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/pbkpaulbocuse/reserve?menu_lists[]=667ba8e4aded4d4f8076fa48&utm_source=france_restaurant_week'
    ],
    [
      'restaurant-tani',
      'https://www.tablecheck.com/restaurant-tani',
      'https://www.tablecheck.com/shops/restaurant-tani/reserve',
      '66724f88cdc843ef4f0e4caf',
      'https://www.tablecheck.com/ja/restaurant-tani?menu_lists[]=66724f88cdc843ef4f0e4caf&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/restaurant-tani/reserve?menu_lists[]=66724f88cdc843ef4f0e4caf&utm_source=france_restaurant_week'
    ],
    [
      'morioka-metropolitan-mont',
      'https://www.tablecheck.com/morioka-metropolitan-mont',
      'https://www.tablecheck.com/shops/morioka-metropolitan-mont/reserve',
      '668b4bf44fd6cbaa464b2985',
      'https://www.tablecheck.com/ja/morioka-metropolitan-mont?menu_lists[]=668b4bf44fd6cbaa464b2985&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/morioka-metropolitan-mont/reserve?menu_lists[]=668b4bf44fd6cbaa464b2985&utm_source=france_restaurant_week'
    ],
    [
      'kyoto-tokyu-kazahana',
      'https://www.tablecheck.com/kyoto-tokyu-kazahana',
      'https://www.tablecheck.com/shops/kyoto-tokyu-kazahana/reserve',
      '6672528a1c817fda31cd2e32',
      'https://www.tablecheck.com/ja/kyoto-tokyu-kazahana?menu_lists[]=6672528a1c817fda31cd2e32&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/kyoto-tokyu-kazahana/reserve?menu_lists[]=6672528a1c817fda31cd2e32&utm_source=france_restaurant_week'
    ],
    [
      'frhiramatsu',
      'https://www.tablecheck.com/frhiramatsu',
      'https://www.tablecheck.com/shops/frhiramatsu/reserve',
      '667bb1d5c22ea2344bed7308',
      'https://www.tablecheck.com/ja/frhiramatsu?menu_lists[]=667bb1d5c22ea2344bed7308&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/frhiramatsu/reserve?menu_lists[]=667bb1d5c22ea2344bed7308&utm_source=france_restaurant_week'
    ],
    [
      'aic-akitsushima',
      'https://www.tablecheck.com/aic-akitsushima',
      'https://www.tablecheck.com/shops/aic-akitsushima/reserve',
      '667bb4a3701f686702fd9196',
      'https://www.tablecheck.com/ja/aic-akitsushima?menu_lists[]=667bb4a3701f686702fd9196&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/aic-akitsushima/reserve?menu_lists[]=667bb4a3701f686702fd9196&utm_source=france_restaurant_week'
    ],
    [
      'newotani-hakata-castillian',
      'https://www.tablecheck.com/newotani-hakata-castillian',
      'https://www.tablecheck.com/shops/newotani-hakata-castillian/reserve',
      '6672678a133efb8a502949a0',
      'https://www.tablecheck.com/ja/newotani-hakata-castillian?menu_lists[]=6672678a133efb8a502949a0&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/newotani-hakata-castillian/reserve?menu_lists[]=6672678a133efb8a502949a0&utm_source=france_restaurant_week'
    ],
    [
      'ybhtqueenalice',
      'https://www.tablecheck.com/ybhtqueenalice',
      'https://www.tablecheck.com/shops/ybhtqueenalice/reserve',
      '667bbe5b511650492db20ebb',
      'https://www.tablecheck.com/ja/ybhtqueenalice?menu_lists[]=667bbe5b511650492db20ebb&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/ybhtqueenalice/reserve?menu_lists[]=667bbe5b511650492db20ebb&utm_source=france_restaurant_week'
    ],
    [
      'funatsuru',
      'https://www.tablecheck.com/funatsuru',
      'https://www.tablecheck.com/shops/funatsuru/reserve',
      '667bc19e70d42789a1085db6',
      'https://www.tablecheck.com/ja/funatsuru?menu_lists[]=667bc19e70d42789a1085db6&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/funatsuru/reserve?menu_lists[]=667bc19e70d42789a1085db6&utm_source=france_restaurant_week'
    ],
    [
      'le-un',
      'https://www.tablecheck.com/le-un',
      'https://www.tablecheck.com/shops/le-un/reserve',
      '667cda1ee6ef71dbb24fa534',
      'https://www.tablecheck.com/ja/le-un?menu_lists[]=667cda1ee6ef71dbb24fa534&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/le-un/reserve?menu_lists[]=667cda1ee6ef71dbb24fa534&utm_source=france_restaurant_week'
    ],
    [
      'arkh-dining',
      'https://www.tablecheck.com/arkh-dining',
      'https://www.tablecheck.com/shops/arkh-dining/reserve',
      '667e3878e6ef71dbb24fd4e8',
      'https://www.tablecheck.com/ja/arkh-dining?menu_lists[]=667e3878e6ef71dbb24fd4e8&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/arkh-dining/reserve?menu_lists[]=667e3878e6ef71dbb24fd4e8&utm_source=france_restaurant_week'
    ],
    [
      'the-grand47',
      'https://www.tablecheck.com/the-grand47',
      'https://www.tablecheck.com/shops/the-grand47/reserve',
      '667e329be8f16d8499113a2e',
      'https://www.tablecheck.com/ja/the-grand47?menu_lists[]=667e329be8f16d8499113a2e&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/the-grand47/reserve?menu_lists[]=667e329be8f16d8499113a2e&utm_source=france_restaurant_week'
    ],
    [
      'gento',
      'https://www.tablecheck.com/gento',
      'https://www.tablecheck.com/shops/gento/reserve',
      '66725359639e27575de34fb3',
      'https://www.tablecheck.com/ja/gento?menu_lists[]=66725359639e27575de34fb3&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/gento/reserve?menu_lists[]=66725359639e27575de34fb3&utm_source=france_restaurant_week'
    ],
    [
      'higashiyamagarden',
      'https://www.tablecheck.com/higashiyamagarden',
      'https://www.tablecheck.com/shops/higashiyamagarden/reserve',
      '6683b05e28203a6e3a387911',
      'https://www.tablecheck.com/ja/higashiyamagarden?menu_lists[]=6683b05e28203a6e3a387911&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/higashiyamagarden/reserve?menu_lists[]=6683b05e28203a6e3a387911&utm_source=france_restaurant_week'
    ],
    [
      'srhiramatsu',
      'https://www.tablecheck.com/srhiramatsu',
      'https://www.tablecheck.com/shops/srhiramatsu/reserve',
      '668b9fc33ec6b9ff5108c351',
      'https://www.tablecheck.com/ja/srhiramatsu?menu_lists[]=668b9fc33ec6b9ff5108c351&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/srhiramatsu/reserve?menu_lists[]=668b9fc33ec6b9ff5108c351&utm_source=france_restaurant_week'
    ],
    [
      'leai',
      'https://www.tablecheck.com/leai',
      'https://www.tablecheck.com/shops/leai/reserve',
      '6684acfcbc3d80fd0e583a53',
      'https://www.tablecheck.com/ja/leai?menu_lists[]=6684acfcbc3d80fd0e583a53&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/leai/reserve?menu_lists[]=6684acfcbc3d80fd0e583a53&utm_source=france_restaurant_week'
    ],
    [
      'watahan-oncri',
      'https://www.tablecheck.com/watahan-oncri',
      'https://www.tablecheck.com/shops/watahan-oncri/reserve',
      '6673baf38deabf53ba686b5f',
      'https://www.tablecheck.com/ja/watahan-oncri?menu_lists[]=6673baf38deabf53ba686b5f&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/watahan-oncri/reserve?menu_lists[]=6673baf38deabf53ba686b5f&utm_source=france_restaurant_week'
    ],
    [
      'lart-et-la-manier',
      'https://www.tablecheck.com/lart-et-la-manier',
      'https://www.tablecheck.com/shops/lart-et-la-manier/reserve',
      '6684c385f511212d77ade010',
      'https://www.tablecheck.com/ja/lart-et-la-manier?menu_lists[]=6684c385f511212d77ade010&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/lart-et-la-manier/reserve?menu_lists[]=6684c385f511212d77ade010&utm_source=france_restaurant_week'
    ],
    [
      'la-terrasse-irisee',
      'https://www.tablecheck.com/la-terrasse-irisee',
      'https://www.tablecheck.com/shops/la-terrasse-irisee/reserve',
      '66aca8c4c9f4b4b108876193',
      'https://www.tablecheck.com/ja/la-terrasse-irisee?menu_lists[]=66aca8c4c9f4b4b108876193&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/la-terrasse-irisee/reserve?menu_lists[]=66aca8c4c9f4b4b108876193&utm_source=france_restaurant_week'
    ],
    [
      'la-maison-de-graciani',
      'https://www.tablecheck.com/la-maison-de-graciani',
      'https://www.tablecheck.com/shops/la-maison-de-graciani/reserve',
      '668b58ef1a3dac32825874d1',
      'https://www.tablecheck.com/ja/la-maison-de-graciani?menu_lists[]=668b58ef1a3dac32825874d1&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/la-maison-de-graciani/reserve?menu_lists[]=668b58ef1a3dac32825874d1&utm_source=france_restaurant_week'
    ],
    [
      'hotelniwa-lieu',
      'https://www.tablecheck.com/hotelniwa-lieu',
      'https://www.tablecheck.com/shops/hotelniwa-lieu/reserve',
      '669f879fdb45abec03c31475',
      'https://www.tablecheck.com/ja/hotelniwa-lieu?menu_lists[]=669f879fdb45abec03c31475&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/hotelniwa-lieu/reserve?menu_lists[]=669f879fdb45abec03c31475&utm_source=france_restaurant_week'
    ],
    [
      'hikari-ya-nishi',
      'https://www.tablecheck.com/hikari-ya-nishi',
      'https://www.tablecheck.com/shops/hikari-ya-nishi/reserve',
      '668ba3a30ad60967526354ef',
      'https://www.tablecheck.com/ja/hikari-ya-nishi?menu_lists[]=668ba3a30ad60967526354ef&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/hikari-ya-nishi/reserve?menu_lists[]=668ba3a30ad60967526354ef&utm_source=france_restaurant_week'
    ],
    [
      'antibestokyo',
      'https://www.tablecheck.com/antibestokyo',
      'https://www.tablecheck.com/shops/antibestokyo/reserve',
      '668b6baa2238c07d29de033f',
      'https://www.tablecheck.com/ja/antibestokyo?menu_lists[]=668b6baa2238c07d29de033f&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/antibestokyo/reserve?menu_lists[]=668b6baa2238c07d29de033f&utm_source=france_restaurant_week'
    ],
    [
      'jourdemarche-tokyo',
      'https://www.tablecheck.com/jourdemarche-tokyo',
      'https://www.tablecheck.com/shops/jourdemarche-tokyo/reserve',
      '668b6e63b4273da85ebfce6f',
      'https://www.tablecheck.com/ja/jourdemarche-tokyo?menu_lists[]=668b6e63b4273da85ebfce6f&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/jourdemarche-tokyo/reserve?menu_lists[]=668b6e63b4273da85ebfce6f&utm_source=france_restaurant_week'
    ],
    [
      'nishitetsulacascade',
      'https://www.tablecheck.com/nishitetsulacascade',
      'https://www.tablecheck.com/shops/nishitetsulacascade/reserve',
      '66b307f957c18e08350701b6',
      'https://www.tablecheck.com/ja/nishitetsulacascade?menu_lists[]=66b307f957c18e08350701b6&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/nishitetsulacascade/reserve?menu_lists[]=66b307f957c18e08350701b6&utm_source=france_restaurant_week'
    ],
    [
      'anacrowneplaza-osaka-maisontateruyoshino',
      'https://www.tablecheck.com/anacrowneplaza-osaka-maisontateruyoshino',
      'https://www.tablecheck.com/shops/anacrowneplaza-osaka-maisontateruyoshino/reserve',
      '66a779ef9b07f958c78c42b2',
      'https://www.tablecheck.com/ja/anacrowneplaza-osaka-maisontateruyoshino?menu_lists[]=66a779ef9b07f958c78c42b2&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/anacrowneplaza-osaka-maisontateruyoshino/reserve?menu_lists[]=66a779ef9b07f958c78c42b2&utm_source=france_restaurant_week'
    ],
    [
      'portom-tateruyoshino',
      'https://www.tablecheck.com/portom-tateruyoshino',
      'https://www.tablecheck.com/shops/portom-tateruyoshino/reserve',
      '667b9d7aee15b7e62ffd9921',
      'https://www.tablecheck.com/ja/portom-tateruyoshino?menu_lists[]=667b9d7aee15b7e62ffd9921&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/portom-tateruyoshino/reserve?menu_lists[]=667b9d7aee15b7e62ffd9921&utm_source=france_restaurant_week'
    ],
    [
      'mikuni-marunouchi',
      'https://www.tablecheck.com/mikuni-marunouchi',
      'https://www.tablecheck.com/shops/mikuni-marunouchi/reserve',
      '66c596e1cc18bbf42da841d6',
      'https://www.tablecheck.com/ja/mikuni-marunouchi?menu_lists[]=66c596e1cc18bbf42da841d6&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/mikuni-marunouchi/reserve?menu_lists[]=66c596e1cc18bbf42da841d6&utm_source=france_restaurant_week'
    ],
    [
      'lyondelyon',
      'https://www.tablecheck.com/lyondelyon',
      'https://www.tablecheck.com/shops/lyondelyon/reserve',
      '668b4725756a66d381feab38',
      'https://www.tablecheck.com/ja/lyondelyon?menu_lists[]=668b4725756a66d381feab38&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/lyondelyon/reserve?menu_lists[]=668b4725756a66d381feab38&utm_source=france_restaurant_week'
    ],
    [
      'petillant',
      'https://www.tablecheck.com/petillant',
      'https://www.tablecheck.com/petillant/reserve',
      '668b49577ea170f4ee5871dd',
      'https://www.tablecheck.com/ja/petillant?menu_lists[]=668b49577ea170f4ee5871dd&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/petillant/reserve?menu_lists[]=668b49577ea170f4ee5871dd&utm_source=france_restaurant_week'
    ],
    [
      'gilberto',
      'https://www.tablecheck.com/gilberto',
      'https://www.tablecheck.com/shops/gilberto/reserve',
      '667392107ecc633474ecf092',
      'https://www.tablecheck.com/ja/gilberto?menu_lists[]=667392107ecc633474ecf092&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/gilberto/reserve?menu_lists[]=667392107ecc633474ecf092&utm_source=france_restaurant_week'
    ],
    [
      'restaurant-helice',
      'https://www.tablecheck.com/restaurant-helice',
      'https://www.tablecheck.com/shops/restaurant-helice/reserve',
      '666fc5dd68cfe8966ecccbc8',
      'https://www.tablecheck.com/ja/restaurant-helice?menu_lists[]=666fc5dd68cfe8966ecccbc8&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/restaurant-helice/reserve?menu_lists[]=666fc5dd68cfe8966ecccbc8&utm_source=france_restaurant_week'
    ],
    [
      'akihisahanda',
      'https://www.tablecheck.com/akihisahanda',
      'https://www.tablecheck.com/shops/akihisahanda/reserve',
      '667394047c2e9b536b1a7810',
      'https://www.tablecheck.com/ja/akihisahanda?menu_lists[]=667394047c2e9b536b1a7810&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/akihisahanda/reserve?menu_lists[]=667394047c2e9b536b1a7810&utm_source=france_restaurant_week'
    ],
    [
      'iwb-romanee',
      'https://www.tablecheck.com/iwb-romanee',
      'https://www.tablecheck.com/shops/iwb-romanee/reserve',
      '666fa473f5ec2b15079ccafb',
      'https://www.tablecheck.com/ja/iwb-romanee?menu_lists[]=666fa473f5ec2b15079ccafb&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/iwb-romanee/reserve?menu_lists[]=666fa473f5ec2b15079ccafb&utm_source=france_restaurant_week'
    ],
    [
      'fourseasons-tokyo-maisonmarunouchi',
      'https://www.tablecheck.com/fourseasons-tokyo-maisonmarunouchi',
      'https://www.tablecheck.com/shops/fourseasons-tokyo-maisonmarunouchi/reserve',
      '666fd139f0afd92abb0df43e',
      'https://www.tablecheck.com/ja/fourseasons-tokyo-maisonmarunouchi?menu_lists[]=666fd139f0afd92abb0df43e&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/fourseasons-tokyo-maisonmarunouchi/reserve?menu_lists[]=666fd139f0afd92abb0df43e&utm_source=france_restaurant_week'
    ],
    [
      'malusfantastica',
      'https://www.tablecheck.com/malusfantastica',
      'https://www.tablecheck.com/shops/malusfantastica/reserve',
      '666fd788a3db3b405a2e4b5a',
      'https://www.tablecheck.com/ja/malusfantastica?menu_lists[]=666fd788a3db3b405a2e4b5a&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/malusfantastica/reserve?menu_lists[]=666fd788a3db3b405a2e4b5a&utm_source=france_restaurant_week'
    ],
    [
      'aubergequatresaisons',
      'https://www.tablecheck.com/aubergequatresaisons',
      'https://www.tablecheck.com/shops/aubergequatresaisons/reserve',
      '666fef3de5f3b66ca97c0af0',
      'https://www.tablecheck.com/ja/aubergequatresaisons?menu_lists[]=666fef3de5f3b66ca97c0af0&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/aubergequatresaisons/reserve?menu_lists[]=666fef3de5f3b66ca97c0af0&utm_source=france_restaurant_week'
    ],
    [
      'un-treize',
      'https://www.tablecheck.com/un-treize',
      'https://www.tablecheck.com/shops/un-treize/reserve',
      '6670e75722c39d521640ea56',
      'https://www.tablecheck.com/ja/un-treize?menu_lists[]=6670e75722c39d521640ea56&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/un-treize/reserve?menu_lists[]=6670e75722c39d521640ea56&utm_source=france_restaurant_week'
    ],
    [
      'lull',
      'https://www.tablecheck.com/lull',
      'https://www.tablecheck.com/shops/lull/reserve',
      '6670eacbb98c3922d92e6a3b',
      'https://www.tablecheck.com/ja/lull?menu_lists[]=6670eacbb98c3922d92e6a3b&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/lull/reserve?menu_lists[]=6670eacbb98c3922d92e6a3b&utm_source=france_restaurant_week'
    ],
    [
      'kobe-kitano-terrasse',
      'https://www.tablecheck.com/kobe-kitano-terrasse',
      'https://www.tablecheck.com/shops/kobe-kitano-terrasse/reserve',
      '6683a4592cbdd2667b4ba631',
      'https://www.tablecheck.com/ja/kobe-kitano-terrasse?menu_lists[]=6683a4592cbdd2667b4ba631&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/kobe-kitano-terrasse/reserve?menu_lists[]=6683a4592cbdd2667b4ba631&utm_source=france_restaurant_week'
    ],
    [
      'kyoto-tatsuki',
      'https://www.tablecheck.com/kyoto-tatsuki',
      'https://www.tablecheck.com/shops/kyoto-tatsuki/reserve',
      '669f82c6e0aeaacda578253a',
      'https://www.tablecheck.com/ja/kyoto-tatsuki?menu_lists[]=669f82c6e0aeaacda578253a&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/kyoto-tatsuki/reserve?menu_lists[]=669f82c6e0aeaacda578253a&utm_source=france_restaurant_week'
    ],
    [
      'moss-okinawa',
      'https://www.tablecheck.com/moss-okinawa',
      'https://www.tablecheck.com/shops/moss-okinawa/reserve',
      '6670f159b429002ff1f177ec',
      'https://www.tablecheck.com/ja/moss-okinawa?menu_lists[]=6670f159b429002ff1f177ec&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/moss-okinawa/reserve?menu_lists[]=6670f159b429002ff1f177ec&utm_source=france_restaurant_week'
    ],
    [
      'okuratokyobay-fontana',
      'https://www.tablecheck.com/okuratokyobay-fontana',
      'https://www.tablecheck.com/shops/okuratokyobay-fontana/reserve',
      '6670f5751c817fda31ccf734',
      'https://www.tablecheck.com/ja/okuratokyobay-fontana?menu_lists[]=6670f5751c817fda31ccf734&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/okuratokyobay-fontana/reserve?menu_lists[]=6670f5751c817fda31ccf734&utm_source=france_restaurant_week'
    ],
    [
      'yabu-distillery',
      'https://www.tablecheck.com/yabu-distillery',
      'https://www.tablecheck.com/yabu-distillery/reserve',
      '6670fc5d89d82a20c9aab806',
      'https://www.tablecheck.com/ja/yabu-distillery?menu_lists[]=6670fc5d89d82a20c9aab806&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/yabu-distillery/reserve?menu_lists[]=6670fc5d89d82a20c9aab806&utm_source=france_restaurant_week'
    ],
    [
      'session-hamacho',
      'https://www.tablecheck.com/session-hamacho',
      'https://www.tablecheck.com/shops/session-hamacho/reserve',
      '667399d37965e29d69dc815d',
      'https://www.tablecheck.com/ja/session-hamacho?menu_lists[]=667399d37965e29d69dc815d&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/session-hamacho/reserve?menu_lists[]=667399d37965e29d69dc815d&utm_source=france_restaurant_week'
    ],
    [
      'ginza-skylounge',
      'https://www.tablecheck.com/ginza-skylounge',
      'https://www.tablecheck.com/shops/ginza-skylounge/reserve',
      '66724535db080d60ee7c6c1a',
      'https://www.tablecheck.com/ja/ginza-skylounge?menu_lists[]=66724535db080d60ee7c6c1a&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/ginza-skylounge/reserve?menu_lists[]=66724535db080d60ee7c6c1a&utm_source=france_restaurant_week'
    ],
    [
      'aileblanche',
      'https://www.tablecheck.com/aileblanche',
      'https://www.tablecheck.com/shops/aileblanche/reserve',
      '6673af09ab1152e137a5e0d5',
      'https://www.tablecheck.com/ja/aileblanche?menu_lists[]=6673af09ab1152e137a5e0d5&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/aileblanche/reserve?menu_lists[]=6673af09ab1152e137a5e0d5&utm_source=france_restaurant_week'
    ],
    [
      'armorica',
      'https://www.tablecheck.com/armorica',
      'https://www.tablecheck.com/shops/armorica/reserve',
      '667247dfb429002ff1f1ac46',
      'https://www.tablecheck.com/ja/armorica?menu_lists[]=667247dfb429002ff1f1ac46&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/armorica/reserve?menu_lists[]=667247dfb429002ff1f1ac46&utm_source=france_restaurant_week'
    ],
    [
      'chhiramatsu',
      'https://www.tablecheck.com/chhiramatsu',
      'https://www.tablecheck.com/shops/chhiramatsu/reserve',
      '66c55bddfd52d2e505a83725',
      'https://www.tablecheck.com/ja/chhiramatsu?menu_lists[]=66c55bddfd52d2e505a83725&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/chhiramatsu/reserve?menu_lists[]=66c55bddfd52d2e505a83725&utm_source=france_restaurant_week'
    ],
    [
      'nemotolabo',
      'https://www.tablecheck.com/nemotolabo',
      'https://www.tablecheck.com/nemotolabo/reserve',
      '66724cff68cfe8966ecd1b80',
      'https://www.tablecheck.com/ja/nemotolabo?menu_lists[]=66724cff68cfe8966ecd1b80&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/nemotolabo/reserve?menu_lists[]=66724cff68cfe8966ecd1b80&utm_source=france_restaurant_week'
    ],
    [
      'pbgpaulbocuse',
      'https://www.tablecheck.com/pbgpaulbocuse',
      'https://www.tablecheck.com/shops/pbgpaulbocuse/reserve',
      '667ba163d501ce8f903e4411',
      'https://www.tablecheck.com/ja/pbgpaulbocuse?menu_lists[]=667ba163d501ce8f903e4411&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/pbgpaulbocuse/reserve?menu_lists[]=667ba163d501ce8f903e4411&utm_source=france_restaurant_week'
    ],
    [
      'sentiamo',
      'https://www.tablecheck.com/sentiamo',
      'https://www.tablecheck.com/shops/sentiamo/reserve',
      '6673b245fa8d9716516869b9',
      'https://www.tablecheck.com/ja/sentiamo?menu_lists[]=6673b245fa8d9716516869b9&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/sentiamo/reserve?menu_lists[]=6673b245fa8d9716516869b9&utm_source=france_restaurant_week'
    ],
    [
      'winebarvinvino',
      'https://www.tablecheck.com/winebarvinvino',
      'https://www.tablecheck.com/winebarvinvino/reserve',
      '66a8b994ad743f32f36b56fd',
      'https://www.tablecheck.com/ja/winebarvinvino?menu_lists[]=66a8b994ad743f32f36b56fd&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/winebarvinvino/reserve?menu_lists[]=66a8b994ad743f32f36b56fd&utm_source=france_restaurant_week'
    ],
    [
      'princess-kyoto-ambercourt',
      'https://www.tablecheck.com/princess-kyoto-ambercourt',
      'https://www.tablecheck.com/shops/princess-kyoto-ambercourt/reserve',
      '669f6a89282fdf3b948bc78d',
      'https://www.tablecheck.com/ja/princess-kyoto-ambercourt?menu_lists[]=669f6a89282fdf3b948bc78d&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/princess-kyoto-ambercourt/reserve?menu_lists[]=669f6a89282fdf3b948bc78d&utm_source=france_restaurant_week'
    ],
    [
      'naomi-ogaki',
      'https://www.tablecheck.com/naomi-ogaki',
      'https://www.tablecheck.com/shops/naomi-ogaki/reserve',
      '667baafed5c77bc566ed743d',
      'https://www.tablecheck.com/ja/naomi-ogaki?menu_lists[]=667baafed5c77bc566ed743d&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/naomi-ogaki/reserve?menu_lists[]=667baafed5c77bc566ed743d&utm_source=france_restaurant_week'
    ],
    [
      'gamagori-classic-hotel-maindining',
      'https://www.tablecheck.com/gamagori-classic-hotel-maindining',
      'https://www.tablecheck.com/shops/gamagori-classic-hotel-maindining/reserve',
      '667baecdaded4d4f8076fb11',
      'https://www.tablecheck.com/ja/gamagori-classic-hotel-maindining?menu_lists[]=667baecdaded4d4f8076fb11&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/gamagori-classic-hotel-maindining/reserve?menu_lists[]=667baecdaded4d4f8076fb11&utm_source=france_restaurant_week'
    ],
    [
      'prince-etoile',
      'https://www.tablecheck.com/prince-etoile',
      'https://www.tablecheck.com/shops/prince-etoile/reserve',
      '667bb7d7adcf86412d0858c6',
      'https://www.tablecheck.com/ja/prince-etoile?menu_lists[]=667bb7d7adcf86412d0858c6&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/prince-etoile/reserve?menu_lists[]=667bb7d7adcf86412d0858c6&utm_source=france_restaurant_week'
    ],
    [
      'f-sunpalace-laputa',
      'https://www.tablecheck.com/f-sunpalace-laputa',
      'https://www.tablecheck.com/shops/f-sunpalace-laputa/reserve',
      '667bbc2436679a6578a9f14e',
      'https://www.tablecheck.com/ja/f-sunpalace-laputa?menu_lists[]=667bbc2436679a6578a9f14e&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/f-sunpalace-laputa/reserve?menu_lists[]=667bbc2436679a6578a9f14e&utm_source=france_restaurant_week'
    ],
    [
      'lodorante',
      'https://www.tablecheck.com/lodorante',
      'https://www.tablecheck.com/shops/lodorante/reserve',
      '66725545db080d60ee7c7127',
      'https://www.tablecheck.com/ja/lodorante?menu_lists[]=66725545db080d60ee7c7127&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/lodorante/reserve?menu_lists[]=66725545db080d60ee7c7127&utm_source=france_restaurant_week'
    ],
    [
      'hon-jin',
      'https://www.tablecheck.com/hon-jin',
      'https://www.tablecheck.com/shops/hon-jin/reserve',
      '667257e3b5b287ba507c7561',
      'https://www.tablecheck.com/ja/hon-jin?menu_lists[]=667257e3b5b287ba507c7561&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/hon-jin/reserve?menu_lists[]=667257e3b5b287ba507c7561&utm_source=france_restaurant_week'
    ],
    [
      'la-rencontre',
      'https://www.tablecheck.com/la-rencontre',
      'https://www.tablecheck.com/shops/la-rencontre/reserve',
      '66727715deb7830ba2ecd2c4',
      'https://www.tablecheck.com/ja/la-rencontre?menu_lists[]=66727715deb7830ba2ecd2c4&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/la-rencontre/reserve?menu_lists[]=66727715deb7830ba2ecd2c4&utm_source=france_restaurant_week'
    ],
    [
      'vmg-hakodate',
      'https://www.tablecheck.com/vmg-hakodate',
      'https://www.tablecheck.com/shops/vmg-hakodate/reserve',
      '667cf4b6029fa6fef01ebf4c',
      'https://www.tablecheck.com/ja/vmg-hakodate?menu_lists[]=667cf4b6029fa6fef01ebf4c&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/vmg-hakodate/reserve?menu_lists[]=667cf4b6029fa6fef01ebf4c&utm_source=france_restaurant_week'
    ],
    [
      'vmg-igaueno',
      'https://www.tablecheck.com/vmg-igaueno',
      'https://www.tablecheck.com/shops/vmg-igaueno/reserve',
      '667bcca697c12f42f8a9f2e5',
      'https://www.tablecheck.com/ja/vmg-igaueno?menu_lists[]=667bcca697c12f42f8a9f2e5&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/vmg-igaueno/reserve?menu_lists[]=667bcca697c12f42f8a9f2e5&utm_source=france_restaurant_week'
    ],
    [
      'ozucastle',
      'https://www.tablecheck.com/ozucastle',
      'https://www.tablecheck.com/shops/ozucastle/reserve',
      '667cc2bf801ca29765a5c7ee',
      'https://www.tablecheck.com/ja/ozucastle?menu_lists[]=667cc2bf801ca29765a5c7ee&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/ozucastle/reserve?menu_lists[]=667cc2bf801ca29765a5c7ee&utm_source=france_restaurant_week'
    ],
    [
      'yame-fukushimastay',
      'https://www.tablecheck.com/yame-fukushimastay',
      'https://www.tablecheck.com/shops/yame-fukushimastay/reserve',
      '667cc5d504a40a9dc410f01b',
      'https://www.tablecheck.com/ja/yame-fukushimastay?menu_lists[]=667cc5d504a40a9dc410f01b&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/yame-fukushimastay/reserve?menu_lists[]=667cc5d504a40a9dc410f01b&utm_source=france_restaurant_week'
    ],
    [
      'cultia-dazaifu',
      'https://www.tablecheck.com/cultia-dazaifu',
      'https://www.tablecheck.com/shops/cultia-dazaifu/reserve',
      '667cca1d7bb2a7485210e919',
      'https://www.tablecheck.com/ja/cultia-dazaifu?menu_lists[]=667cca1d7bb2a7485210e919&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/cultia-dazaifu/reserve?menu_lists[]=667cca1d7bb2a7485210e919&utm_source=france_restaurant_week'
    ],
    [
      'nipponia-takehara',
      'https://www.tablecheck.com/nipponia-takehara',
      'https://www.tablecheck.com/shops/nipponia-takehara/reserve',
      '667ccdb3fda4548ff94f3208',
      'https://www.tablecheck.com/ja/nipponia-takehara?menu_lists[]=667ccdb3fda4548ff94f3208&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/nipponia-takehara/reserve?menu_lists[]=667ccdb3fda4548ff94f3208&utm_source=france_restaurant_week'
    ],
    [
      'nipponia-sawara',
      'https://www.tablecheck.com/nipponia-sawara',
      'https://www.tablecheck.com/shops/nipponia-sawara/reserve',
      '667cd0acf3aa481e0b1a7cf2',
      'https://www.tablecheck.com/ja/nipponia-sawara?menu_lists[]=667cd0acf3aa481e0b1a7cf2&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/nipponia-sawara/reserve?menu_lists[]=667cd0acf3aa481e0b1a7cf2&utm_source=france_restaurant_week'
    ],
    [
      'naramachistay',
      'https://www.tablecheck.com/naramachistay',
      'https://www.tablecheck.com/shops/naramachistay/reserve',
      '667cd3451be81e0a8c4f2e37',
      'https://www.tablecheck.com/ja/naramachistay?menu_lists[]=667cd3451be81e0a8c4f2e37&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/naramachistay/reserve?menu_lists[]=667cd3451be81e0a8c4f2e37&utm_source=france_restaurant_week'
    ],
    [
      'takedacastle',
      'https://www.tablecheck.com/takedacastle',
      'https://www.tablecheck.com/shops/takedacastle/reserve',
      '667cd643de77174a0d8189c9',
      'https://www.tablecheck.com/ja/takedacastle?menu_lists[]=667cd643de77174a0d8189c9&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/takedacastle/reserve?menu_lists[]=667cd643de77174a0d8189c9&utm_source=france_restaurant_week'
    ],
    [
      'sasayamastay',
      'https://www.tablecheck.com/sasayamastay',
      'https://www.tablecheck.com/shops/sasayamastay/reserve',
      '667bbbfaf6b1dd6d879abd00',
      'https://www.tablecheck.com/ja/sasayamastay?menu_lists[]=667bbbfaf6b1dd6d879abd00&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/sasayamastay/reserve?menu_lists[]=667bbbfaf6b1dd6d879abd00&utm_source=france_restaurant_week'
    ],
    [
      'interconti-tokyo-laprovence',
      'https://www.tablecheck.com/interconti-tokyo-laprovence',
      'https://www.tablecheck.com/shops/interconti-tokyo-laprovence/reserve',
      '6683ad3a6360f4fbaeadc264',
      'https://www.tablecheck.com/ja/interconti-tokyo-laprovence?menu_lists[]=6683ad3a6360f4fbaeadc264&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/interconti-tokyo-laprovence/reserve?menu_lists[]=6683ad3a6360f4fbaeadc264&utm_source=france_restaurant_week'
    ],
    [
      'aigrette-himeji',
      'https://www.tablecheck.com/aigrette-himeji',
      'https://www.tablecheck.com/aigrette-himeji/reserve',
      '66a9f694d380ba0db22afebd',
      'https://www.tablecheck.com/ja/aigrette-himeji?menu_lists[]=66a9f694d380ba0db22afebd&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/aigrette-himeji/reserve?menu_lists[]=66a9f694d380ba0db22afebd&utm_source=france_restaurant_week'
    ],
    [
      'quatre-vingt-douze',
      'https://www.tablecheck.com/quatre-vingt-douze',
      'https://www.tablecheck.com/quatre-vingt-douze/reserve',
      '66aa1550c81966955de9c8a3',
      'https://www.tablecheck.com/ja/quatre-vingt-douze?menu_lists[]=66aa1550c81966955de9c8a3&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/quatre-vingt-douze/reserve?menu_lists[]=66aa1550c81966955de9c8a3&utm_source=france_restaurant_week'
    ],
    [
      'noeud-osaka',
      'https://www.tablecheck.com/noeud-osaka',
      'https://www.tablecheck.com/shops/noeud-osaka/reserve',
      '667263f20fd454008b294974',
      'https://www.tablecheck.com/ja/noeud-osaka?menu_lists[]=667263f20fd454008b294974&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/noeud-osaka/reserve?menu_lists[]=667263f20fd454008b294974&utm_source=france_restaurant_week'
    ],
    [
      'restaurantsora',
      'https://www.tablecheck.com/restaurantsora',
      'https://www.tablecheck.com/shops/restaurantsora/reserve',
      '6683b367b9df2f92410f8851',
      'https://www.tablecheck.com/ja/restaurantsora?menu_lists[]=6683b367b9df2f92410f8851&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/restaurantsora/reserve?menu_lists[]=6683b367b9df2f92410f8851&utm_source=france_restaurant_week'
    ],
    [
      'centaragrand-osaka-kunseikitchen',
      'https://www.tablecheck.com/centaragrand-osaka-kunseikitchen',
      'https://www.tablecheck.com/shops/centaragrand-osaka-kunseikitchen/reserve',
      '66727c1324e7700bfabc967a',
      'https://www.tablecheck.com/ja/centaragrand-osaka-kunseikitchen?menu_lists[]=66727c1324e7700bfabc967a&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/centaragrand-osaka-kunseikitchen/reserve?menu_lists[]=66727c1324e7700bfabc967a&utm_source=france_restaurant_week'
    ],
    [
      'centaragrand-osaka-embassyofcrab',
      'https://www.tablecheck.com/centaragrand-osaka-embassyofcrab',
      'https://www.tablecheck.com/shops/centaragrand-osaka-embassyofcrab/reserve',
      '6672944667390a1d37d6923c',
      'https://www.tablecheck.com/ja/centaragrand-osaka-embassyofcrab?menu_lists[]=6672944667390a1d37d6923c&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/centaragrand-osaka-embassyofcrab/reserve?menu_lists[]=6672944667390a1d37d6923c&utm_source=france_restaurant_week'
    ],
    [
      'niddoiseau',
      'https://www.tablecheck.com/niddoiseau',
      'https://www.tablecheck.com/shops/niddoiseau/reserve',
      '668b4e1a0e4c20bbf7a64fbd',
      'https://www.tablecheck.com/ja/niddoiseau?menu_lists[]=668b4e1a0e4c20bbf7a64fbd&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/niddoiseau/reserve?menu_lists[]=668b4e1a0e4c20bbf7a64fbd&utm_source=france_restaurant_week'
    ],
    [
      'westin-yokohama-du-quai',
      'https://www.tablecheck.com/westin-yokohama-du-quai',
      'https://www.tablecheck.com/shops/westin-yokohama-du-quai/reserve',
      '66738d5267390a1d37d6b065',
      'https://www.tablecheck.com/ja/westin-yokohama-du-quai?menu_lists[]=66738d5267390a1d37d6b065&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/westin-yokohama-du-quai/reserve?menu_lists[]=66738d5267390a1d37d6b065&utm_source=france_restaurant_week'
    ],
    [
      'artsimose-restaurant',
      'https://www.tablecheck.com/artsimose-restaurant',
      'https://www.tablecheck.com/shops/artsimose-restaurant/reserve',
      '6684b10e5cd596d2662b04a7',
      'https://www.tablecheck.com/ja/artsimose-restaurant?menu_lists[]=6684b10e5cd596d2662b04a7&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/artsimose-restaurant/reserve?menu_lists[]=6684b10e5cd596d2662b04a7&utm_source=france_restaurant_week'
    ],
    [
      'sr3',
      'https://www.tablecheck.com/sr3',
      'https://www.tablecheck.com/shops/sr3/reserve',
      '6673903dc854315e31d6aadd',
      'https://www.tablecheck.com/ja/sr3?menu_lists[]=6673903dc854315e31d6aadd&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/sr3/reserve?menu_lists[]=6673903dc854315e31d6aadd&utm_source=france_restaurant_week'
    ],
    [
      'add',
      'https://www.tablecheck.com/add',
      'https://www.tablecheck.com/add/reserve',
      '6673b69551b05e9786e535a5',
      'https://www.tablecheck.com/ja/add?menu_lists[]=6673b69551b05e9786e535a5&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/add/reserve?menu_lists[]=6673b69551b05e9786e535a5&utm_source=france_restaurant_week'
    ],
    [
      'boncolore',
      'https://www.tablecheck.com/boncolore',
      'https://www.tablecheck.com/boncolore/reserve',
      '6684b43c28203a6e3a389561',
      'https://www.tablecheck.com/ja/boncolore?menu_lists[]=6684b43c28203a6e3a389561&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/boncolore/reserve?menu_lists[]=6684b43c28203a6e3a389561&utm_source=france_restaurant_week'
    ],
    [
      'bistro-et-toi',
      'https://www.tablecheck.com/bistro-et-toi',
      'https://www.tablecheck.com/bistro-et-toi/reserve',
      '6684b80d96c9c6a2e72b055a',
      'https://www.tablecheck.com/ja/bistro-et-toi?menu_lists[]=6684b80d96c9c6a2e72b055a&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/bistro-et-toi/reserve?menu_lists[]=6684b80d96c9c6a2e72b055a&utm_source=france_restaurant_week'
    ],
    [
      'nikudo58bistro',
      'https://www.tablecheck.com/nikudo58bistro',
      'https://www.tablecheck.com/shops/nikudo58bistro/reserve',
      '6684ba6fdb5ba930650fb214',
      'https://www.tablecheck.com/ja/nikudo58bistro?menu_lists[]=6684ba6fdb5ba930650fb214&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/nikudo58bistro/reserve?menu_lists[]=6684ba6fdb5ba930650fb214&utm_source=france_restaurant_week'
    ],
    [
      'intercontinental-yokohama--pier8',
      'https://www.tablecheck.com/intercontinental-yokohama--pier8',
      'https://www.tablecheck.com/shops/intercontinental-yokohama--pier8/reserve',
      '6684bdecbc3d80fd0e583e5a',
      'https://www.tablecheck.com/ja/intercontinental-yokohama--pier8?menu_lists[]=6684bdecbc3d80fd0e583e5a&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/intercontinental-yokohama--pier8/reserve?menu_lists[]=6684bdecbc3d80fd0e583e5a&utm_source=france_restaurant_week'
    ],
    [
      'intercontinental-yokohama-azur',
      'https://www.tablecheck.com/intercontinental-yokohama-azur',
      'https://www.tablecheck.com/shops/intercontinental-yokohama-azur/reserve',
      '6684d6389a6da47cdc3e88a9',
      'https://www.tablecheck.com/ja/intercontinental-yokohama-azur?menu_lists[]=6684d6389a6da47cdc3e88a9&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/intercontinental-yokohama-azur/reserve?menu_lists[]=6684d6389a6da47cdc3e88a9&utm_source=france_restaurant_week'
    ],
    [
      'uneimmersion',
      'https://www.tablecheck.com/uneimmersion',
      'https://www.tablecheck.com/shops/uneimmersion/reserve',
      '6674fc3d1253e12575667e4f',
      'https://www.tablecheck.com/ja/uneimmersion?menu_lists[]=6674fc3d1253e12575667e4f&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/uneimmersion/reserve?menu_lists[]=6674fc3d1253e12575667e4f&utm_source=france_restaurant_week'
    ],
    [
      'mi-sale-trop-sale',
      'https://www.tablecheck.com/mi-sale-trop-sale',
      'https://www.tablecheck.com/mi-sale-trop-sale/reserve',
      '66791876f624b2f0d5537225',
      'https://www.tablecheck.com/ja/mi-sale-trop-sale?menu_lists[]=66791876f624b2f0d5537225&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/mi-sale-trop-sale/reserve?menu_lists[]=66791876f624b2f0d5537225&utm_source=france_restaurant_week'
    ],
    [
      'requinquer',
      'https://www.tablecheck.com/requinquer',
      'https://www.tablecheck.com/shops/requinquer/reserve',
      '6684c73b2e3affcc9791dfcc',
      'https://www.tablecheck.com/ja/requinquer?menu_lists[]=6684c73b2e3affcc9791dfcc&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/requinquer/reserve?menu_lists[]=6684c73b2e3affcc9791dfcc&utm_source=france_restaurant_week'
    ],
    [
      'restaurant-laine',
      'https://www.tablecheck.com/restaurant-laine',
      'https://www.tablecheck.com/shops/restaurant-laine/reserve',
      '6684c9fbdfae340c1e5846df',
      'https://www.tablecheck.com/ja/restaurant-laine?menu_lists[]=6684c9fbdfae340c1e5846df&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/restaurant-laine/reserve?menu_lists[]=6684c9fbdfae340c1e5846df&utm_source=france_restaurant_week'
    ],
    [
      'authentic-table-tavern',
      'https://www.tablecheck.com/authentic-table-tavern',
      'https://www.tablecheck.com/authentic-table-tavern/reserve',
      '6684cc66dfae340c1e58474c',
      'https://www.tablecheck.com/ja/authentic-table-tavern?menu_lists[]=6684cc66dfae340c1e58474c&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/authentic-table-tavern/reserve?menu_lists[]=6684cc66dfae340c1e58474c&utm_source=france_restaurant_week'
    ],
    [
      'restaurant-dix-neuf',
      'https://www.tablecheck.com/restaurant-dix-neuf',
      'https://www.tablecheck.com/shops/restaurant-dix-neuf/reserve',
      '6684cf2296c9c6a2e72b0ab2',
      'https://www.tablecheck.com/ja/restaurant-dix-neuf?menu_lists[]=6684cf2296c9c6a2e72b0ab2&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/restaurant-dix-neuf/reserve?menu_lists[]=6684cf2296c9c6a2e72b0ab2&utm_source=france_restaurant_week'
    ],
    [
      'editer',
      'https://www.tablecheck.com/editer',
      'https://www.tablecheck.com/shops/editer/reserve',
      '6684d1827d014365963e7821',
      'https://www.tablecheck.com/ja/editer?menu_lists[]=6684d1827d014365963e7821&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/editer/reserve?menu_lists[]=6684d1827d014365963e7821&utm_source=france_restaurant_week'
    ],
    [
      'lienkyoto',
      'https://www.tablecheck.com/lienkyoto',
      'https://www.tablecheck.com/lienkyoto/reserve',
      '668ba2563ec6b9ff5108c396',
      'https://www.tablecheck.com/ja/lienkyoto?menu_lists[]=668ba2563ec6b9ff5108c396&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/lienkyoto/reserve?menu_lists[]=668ba2563ec6b9ff5108c396&utm_source=france_restaurant_week'
    ],
    [
      'newotani-osaka-sakura',
      'https://www.tablecheck.com/newotani-osaka-sakura',
      'https://www.tablecheck.com/shops/newotani-osaka-sakura/reserve',
      '668b5d3c756a66d381feb06a',
      'https://www.tablecheck.com/ja/newotani-osaka-sakura?menu_lists[]=668b5d3c756a66d381feb06a&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/newotani-osaka-sakura/reserve?menu_lists[]=668b5d3c756a66d381feb06a&utm_source=france_restaurant_week'
    ],
    [
      'bistro-sauvage',
      'https://www.tablecheck.com/bistro-sauvage',
      'https://www.tablecheck.com/shops/bistro-sauvage/reserve',
      '668b5fcd0e4c20bbf7a655fb',
      'https://www.tablecheck.com/ja/bistro-sauvage?menu_lists[]=668b5fcd0e4c20bbf7a655fb&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/bistro-sauvage/reserve?menu_lists[]=668b5fcd0e4c20bbf7a655fb&utm_source=france_restaurant_week'
    ],
    [
      'sspourcel',
      'https://www.tablecheck.com/sspourcel',
      'https://www.tablecheck.com/shops/sspourcel/reserve',
      '66aa1f60f525df7e555e40c3',
      'https://www.tablecheck.com/ja/sspourcel?menu_lists[]=66aa1f60f525df7e555e40c3&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/sspourcel/reserve?menu_lists[]=66aa1f60f525df7e555e40c3&utm_source=france_restaurant_week'
    ],
    [
      'sumi',
      'https://www.tablecheck.com/sumi',
      'https://www.tablecheck.com/sumi/reserve',
      '668b630fce618a951b39f25d',
      'https://www.tablecheck.com/ja/sumi?menu_lists[]=668b630fce618a951b39f25d&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/sumi/reserve?menu_lists[]=668b630fce618a951b39f25d&utm_source=france_restaurant_week'
    ],
    [
      'mosscrosstokyo',
      'https://www.tablecheck.com/mosscrosstokyo',
      'https://www.tablecheck.com/shops/mosscrosstokyo/reserve',
      '668c9580b77c5d000afcd42c',
      'https://www.tablecheck.com/ja/mosscrosstokyo?menu_lists[]=668c9580b77c5d000afcd42c&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/mosscrosstokyo/reserve?menu_lists[]=668c9580b77c5d000afcd42c&utm_source=france_restaurant_week'
    ],
    [
      'balcone-shibuya',
      'https://www.tablecheck.com/balcone-shibuya',
      'https://www.tablecheck.com/balcone-shibuya/reserve',
      '668b661943d59e02964b38cc',
      'https://www.tablecheck.com/ja/balcone-shibuya?menu_lists[]=668b661943d59e02964b38cc&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/balcone-shibuya/reserve?menu_lists[]=668b661943d59e02964b38cc&utm_source=france_restaurant_week'
    ],
    [
      'les-mailles',
      'https://www.tablecheck.com/les-mailles',
      'https://www.tablecheck.com/shops/les-mailles/reserve',
      '668b68ed12c84e4a89bfcd69',
      'https://www.tablecheck.com/ja/les-mailles?menu_lists[]=668b68ed12c84e4a89bfcd69&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/les-mailles/reserve?menu_lists[]=668b68ed12c84e4a89bfcd69&utm_source=france_restaurant_week'
    ],
    [
      'l-egoiste',
      'https://www.tablecheck.com/l-egoiste',
      'https://www.tablecheck.com/shops/l-egoiste/reserve',
      '668c988fcb5fe706185547d4',
      'https://www.tablecheck.com/ja/l-egoiste?menu_lists[]=668c988fcb5fe706185547d4&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/l-egoiste/reserve?menu_lists[]=668c988fcb5fe706185547d4&utm_source=france_restaurant_week'
    ],
    [
      'cest-sympa',
      'https://www.tablecheck.com/cest-sympa',
      'https://www.tablecheck.com/shops/cest-sympa/reserve',
      '668c9bba79cb74306b9fbe94',
      'https://www.tablecheck.com/ja/cest-sympa?menu_lists[]=668c9bba79cb74306b9fbe94&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/cest-sympa/reserve?menu_lists[]=668c9bba79cb74306b9fbe94&utm_source=france_restaurant_week'
    ],
    [
      'hotel-nikko-osaka-celebrites',
      'https://www.tablecheck.com/hotel-nikko-osaka-celebrites',
      'https://www.tablecheck.com/shops/hotel-nikko-osaka-celebrites/reserve',
      '668ca09000cd73b1543b83c0',
      'https://www.tablecheck.com/ja/hotel-nikko-osaka-celebrites?menu_lists[]=668ca09000cd73b1543b83c0&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/hotel-nikko-osaka-celebrites/reserve?menu_lists[]=668ca09000cd73b1543b83c0&utm_source=france_restaurant_week'
    ],
    [
      'oriental-hiroshima-ozawa',
      'https://www.tablecheck.com/oriental-hiroshima-ozawa',
      'https://www.tablecheck.com/shops/oriental-hiroshima-ozawa/reserve',
      '668ca3134a9fd3119ba7a09f',
      'https://www.tablecheck.com/ja/oriental-hiroshima-ozawa?menu_lists[]=668ca3134a9fd3119ba7a09f&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/oriental-hiroshima-ozawa/reserve?menu_lists[]=668ca3134a9fd3119ba7a09f&utm_source=france_restaurant_week'
    ],
    [
      'dici-tokyo',
      'https://www.tablecheck.com/dici-tokyo',
      'https://www.tablecheck.com/dici-tokyo/reserve',
      '66aa2dc1c6dee96b4d216c80',
      'https://www.tablecheck.com/ja/dici-tokyo?menu_lists[]=66aa2dc1c6dee96b4d216c80&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/dici-tokyo/reserve?menu_lists[]=66aa2dc1c6dee96b4d216c80&utm_source=france_restaurant_week'
    ],
    [
      'loiseau-de-france',
      'https://www.tablecheck.com/loiseau-de-france',
      'https://www.tablecheck.com/shops/loiseau-de-france/reserve',
      '66aa221ca6c23205953d79b8',
      'https://www.tablecheck.com/ja/loiseau-de-france?menu_lists[]=66aa221ca6c23205953d79b8&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/loiseau-de-france/reserve?menu_lists[]=66aa221ca6c23205953d79b8&utm_source=france_restaurant_week'
    ],
    [
      'restaurant-bellustartokyo',
      'https://www.tablecheck.com/restaurant-bellustartokyo',
      'https://www.tablecheck.com/shops/restaurant-bellustartokyo/reserve',
      '669f8b96ced2836e6bdda997',
      'https://www.tablecheck.com/ja/restaurant-bellustartokyo?menu_lists[]=669f8b96ced2836e6bdda997&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/restaurant-bellustartokyo/reserve?menu_lists[]=669f8b96ced2836e6bdda997&utm_source=france_restaurant_week'
    ],
    [
      'orby',
      'https://www.tablecheck.com/orby',
      'https://www.tablecheck.com/shops/orby/reserve',
      '66aa23c512da8707589f6160',
      'https://www.tablecheck.com/ja/orby?menu_lists[]=66aa23c512da8707589f6160&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/orby/reserve?menu_lists[]=66aa23c512da8707589f6160&utm_source=france_restaurant_week'
    ],
    [
      'grand-ami-kobe',
      'https://www.tablecheck.com/grand-ami-kobe',
      'https://www.tablecheck.com/grand-ami-kobe/reserve',
      '66aa2812c6dee96b4d216c06',
      'https://www.tablecheck.com/ja/grand-ami-kobe?menu_lists[]=66aa2812c6dee96b4d216c06&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/grand-ami-kobe/reserve?menu_lists[]=66aa2812c6dee96b4d216c06&utm_source=france_restaurant_week'
    ],
    [
      'couche-bbs',
      'https://www.tablecheck.com/couche-bbs',
      'https://www.tablecheck.com/shops/couche-bbs/reserve',
      '66aa2add58be14b424cdfe97',
      'https://www.tablecheck.com/ja/couche-bbs?menu_lists[]=66aa2add58be14b424cdfe97&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/couche-bbs/reserve?menu_lists[]=66aa2add58be14b424cdfe97&utm_source=france_restaurant_week'
    ],
    [
      'mezzaninetokyo',
      'https://www.tablecheck.com/mezzaninetokyo',
      'https://www.tablecheck.com/shops/mezzaninetokyo/reserve',
      '66b30dd75571f5205b48da9f',
      'https://www.tablecheck.com/ja/mezzaninetokyo?menu_lists[]=66b30dd75571f5205b48da9f&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/mezzaninetokyo/reserve?menu_lists[]=66b30dd75571f5205b48da9f&utm_source=france_restaurant_week'
    ],
    [
      'imagami',
      'https://www.tablecheck.com/imagami',
      'https://www.tablecheck.com/imagami/reserve',
      '66c6ad860d529afeb2a2f842',
      'https://www.tablecheck.com/ja/imagami?menu_lists[]=66c6ad860d529afeb2a2f842&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/imagami/reserve?menu_lists[]=66c6ad860d529afeb2a2f842&utm_source=france_restaurant_week'
    ],
    [
      'sans-maquillage',
      'https://www.tablecheck.com/sans-maquillage',
      'https://www.tablecheck.com/sans-maquillage/reserve',
      '66c83e4730ddf17e7fa35356',
      'https://www.tablecheck.com/ja/sans-maquillage?menu_lists[]=66c83e4730ddf17e7fa35356&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/sans-maquillage/reserve?menu_lists[]=66c83e4730ddf17e7fa35356&utm_source=france_restaurant_week'
    ],
    [
      'le-benkei',
      'https://www.tablecheck.com/le-benkei',
      'https://www.tablecheck.com/le-benkei/reserve',
      '66c6e9fa6a8c05100edfb363',
      'https://www.tablecheck.com/ja/le-benkei?menu_lists[]=66c6e9fa6a8c05100edfb363&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/le-benkei/reserve?menu_lists[]=66c6e9fa6a8c05100edfb363&utm_source=france_restaurant_week'
    ],
    [
      'interconti-tokyo-manhattan',
      'https://www.tablecheck.com/interconti-tokyo-manhattan',
      'https://www.tablecheck.com/shops/interconti-tokyo-manhattan/reserve',
      '66d00519869545e5910430a2',
      'https://www.tablecheck.com/ja/interconti-tokyo-manhattan?menu_lists[]=66d00519869545e5910430a2&utm_source=france_restaurant_week',
      'https://www.tablecheck.com/ja/shops/interconti-tokyo-manhattan/reserve?menu_lists[]=66d00519869545e5910430a2&utm_source=france_restaurant_week'
    ]
  ],
  SHOP_CARD_URLS_NO_DINER_DATA: [
    [
      'umito-sakana',
      'https://www.tablecheck.com/ja/umito-sakana?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/umito-sakana/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'unisei-nishiazabu',
      'https://www.tablecheck.com/ja/unisei-nishiazabu?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/unisei-nishiazabu/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'osteria-tono',
      'https://www.tablecheck.com/ja/osteria-tono?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/osteria-tono/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'sushimonji-shinmon',
      'https://www.tablecheck.com/ja/sushimonji-shinmon?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/sushimonji-shinmon/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'communico',
      'https://www.tablecheck.com/ja/communico?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/communico/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'saveur-sapporo',
      'https://www.tablecheck.com/ja/saveur-sapporo?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/saveur-sapporo/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'sushi-wakon-tokyo',
      'https://www.tablecheck.com/ja/sushi-wakon-tokyo?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/sushi-wakon-tokyo/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'daikanyama-kurumaya',
      'https://www.tablecheck.com/ja/daikanyama-kurumaya?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/daikanyama-kurumaya/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'nayutaka',
      'https://www.tablecheck.com/ja/nayutaka?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/nayutaka/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'noboruya-kanazawa',
      'https://www.tablecheck.com/ja/noboruya-kanazawa?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/noboruya-kanazawa/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'patisserie-parola',
      'https://www.tablecheck.com/ja/patisserie-parola?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/patisserie-parola/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'hibikore-nikujitsu',
      'https://www.tablecheck.com/ja/hibikore-nikujitsu?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/hibikore-nikujitsu/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'fratelli-paradiso',
      'https://www.tablecheck.com/ja/fratelli-paradiso?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/fratelli-paradiso/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'citabria-baypark',
      'https://www.tablecheck.com/ja/citabria-baypark?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/citabria-baypark/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'benjamin-steak-house-kioicho',
      'https://www.tablecheck.com/ja/benjamin-steak-house-kioicho?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/benjamin-steak-house-kioicho/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'benjamin-steak-house-kyoto',
      'https://www.tablecheck.com/ja/benjamin-steak-house-kyoto?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/benjamin-steak-house-kyoto/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'marutamachi-yangas',
      'https://www.tablecheck.com/ja/marutamachi-yangas?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/marutamachi-yangas/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'gobelins',
      'https://www.tablecheck.com/ja/gobelins?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/gobelins/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'imperial-tokyo-la-brasserie',
      'https://www.tablecheck.com/ja/imperial-tokyo-la-brasserie?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/imperial-tokyo-la-brasserie/reserve?utm_source=contactless_pay_restaurants'
    ],
    [
      'lorange-sapporo',
      'https://www.tablecheck.com/ja/lorange-sapporo?utm_source=contactless_pay_restaurants',
      'https://www.tablecheck.com/ja/shops/lorange-sapporo/reserve?utm_source=contactless_pay_restaurants'
    ]
  ]
};
